import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal, Input, Divider, notification, Card } from "antd";
import Cookies from "js-cookie";
import { backendURL } from "../Globals";
import "../NewsComponent.css"; // 🔹 Asegurar la importación del CSS correcto

const NewsComponent = () => {
    const [news, setNews] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showAdminPanel, setShowAdminPanel] = useState(false);
    const [newNews, setNewNews] = useState({ title: "", content: "", date: "" });

    useEffect(() => {
        fetchNews();
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        setIsLoggedIn(!!apiKey);
        setShowAdminPanel(!!apiKey); // Asegurar que solo se active si hay autenticación
    }, []);
    

    // 🔹 Obtener noticias
    const fetchNews = async () => {
        try {
            const response = await axios.get(`${backendURL}/news`);
            setNews(response.data);
        } catch (error) {
            console.error("Error fetching news:", error);
            notification.error({ message: "Error al obtener las noticias" });
        }
    };

    // 🔹 Añadir una nueva noticia con fecha
    const handleAddNews = async () => {
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        if (!apiKey) {
            notification.error({ message: "No estás autenticado" });
            return;
        }

        const today = new Date().toISOString().split("T")[0]; // Fecha en formato YYYY-MM-DD

        try {
            const response = await axios.post(`${backendURL}/news`, { ...newNews, date: today }, {
                headers: { Authorization: `Bearer ${apiKey}` }
            });

            if (response.data.success) {
                setNews([{ ...newNews, date: today, id: response.data.newsId }, ...news]);
                setNewNews({ title: "", content: "", date: "" });
                notification.success({ message: "Noticia añadida correctamente" });
            }
        } catch (error) {
            console.error("Error adding news:", error);
            notification.error({ message: "Error al añadir la noticia" });
        }
    };

    // 🔹 Editar una noticia
    const handleEditNews = async (id, updatedTitle, updatedContent) => {
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        if (!apiKey) return;

        try {
            await axios.put(`${backendURL}/news/${id}`, { title: updatedTitle, content: updatedContent }, {
                headers: { Authorization: `Bearer ${apiKey}` }
            });

            setNews(news.map(n => (n.id === id ? { ...n, title: updatedTitle, content: updatedContent } : n)));
            notification.success({ message: "Noticia editada correctamente" });
        } catch (error) {
            console.error("Error updating news:", error);
            notification.error({ message: "Error al editar la noticia" });
        }
    };

    // 🔹 Eliminar una noticia con confirmación
    const handleDeleteNews = (id) => {
        Modal.confirm({
            title: "¿Estás seguro de eliminar esta noticia?",
            content: "Esta acción no se puede deshacer.",
            okText: "Sí, eliminar",
            okType: "danger",
            cancelText: "Cancelar",
            onOk: async () => {
                const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
                if (!apiKey) {
                    notification.error({ message: "No estás autenticado" });
                    return;
                }

                try {
                    await axios.delete(`${backendURL}/news/${id}`, {
                        headers: { Authorization: `Bearer ${apiKey}` }
                    });

                    setNews(news.filter(n => n.id !== id));
                    notification.success({ message: "Noticia eliminada correctamente" });
                } catch (error) {
                    console.error("Error deleting news:", error);
                    notification.error({ message: "Error al eliminar la noticia" });
                }
            }
        });
    };

    return (
        <div className="about-container">
            <h2 className="about-title">Últimas Noticias</h2>

           {/* 🔹 Mostrar noticias en una única card con scroll */}
           
    <div className="news-scroll">
        {news.length === 0 ? (
            <p>No hay novedades por el momento.</p>
        ) : (
            news.map(n => (
                <div key={n.id} className="news-item">
                    <div className="news-header">
    <span className="news-date">{n.date}</span>
    <span className="news-title">{n.title}</span>
</div>


                    <p className="news-content">{n.content}</p>

                    {/* 🔹 Opciones de edición/eliminación solo si el usuario está autenticado */}
                    {isLoggedIn && showAdminPanel && (
    <div className="news-admin-actions">
        <Button
            type="primary"
            onClick={() => {
                const updatedTitle = prompt("Editar título:", n.title);
                const updatedContent = prompt("Editar contenido:", n.content);
                if (updatedTitle && updatedContent) {
                    handleEditNews(n.id, updatedTitle, updatedContent);
                }
            }}
        >
            ✏️ Editar
        </Button>
        <Button type="link" danger onClick={() => handleDeleteNews(n.id)}>
            🗑️ Eliminar
        </Button>
    </div>
)}

                    <Divider /> {/* 🔹 Separador entre noticias */}
                </div>
            ))
        )}
    </div> 


            {/* 🔹 Mostrar botón para activar/desactivar administración solo si el usuario está autenticado */}
            {isLoggedIn && (
    <Button type="primary" onClick={() => setShowAdminPanel(!showAdminPanel)}>
        {showAdminPanel ? "Ocultar administración" : "Administrar noticias"}
    </Button>
)}


            {/* 🔹 Sección para añadir noticias (oculta por defecto) */}
            {isLoggedIn && showAdminPanel && (
                <div className="add-news-section">
                    <h3>Añadir nueva noticia</h3>
                    <Divider />
                    <Input
                        placeholder="Título"
                        value={newNews.title}
                        onChange={e => setNewNews({ ...newNews, title: e.target.value })}
                        style={{ marginBottom: "10px", width: "250px" }}
                    />
                    <Input.TextArea
                        placeholder="Contenido"
                        value={newNews.content}
                        onChange={e => setNewNews({ ...newNews, content: e.target.value })}
                        rows={3}
                        style={{ marginBottom: "10px", width: "250px" }}
                    />
                    <Button type="primary" onClick={handleAddNews} style={{ marginTop: "10px" }}>
                        Añadir Noticia
                    </Button>
                </div>
            )}
        </div>
    );
};

export default NewsComponent;
